var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatMentioni = function SvgChatMentioni(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M12 7.5a4.5 4.5 0 0 0 0 9 .438.438 0 0 0 0-.875A3.625 3.625 0 1 1 15.625 12c0 1.1-.287 1.813-.775 1.95a.59.59 0 0 1-.538-.087v-3.738a.438.438 0 1 0-.875 0v.075a2.313 2.313 0 1 0 0 3.6v.075a.5.5 0 0 0 .05.2.88.88 0 0 0 .375.537 1.45 1.45 0 0 0 .812.238 1.6 1.6 0 0 0 .713-.175c.5-.275 1.113-.963 1.113-2.675A4.505 4.505 0 0 0 12 7.5m0 5.938A1.438 1.438 0 1 1 13.438 12 1.446 1.446 0 0 1 12 13.438"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatMentioni);
export default ForwardRef;